export default "__VITE_ASSET__ChDKYBqg__"